import { useMemo } from 'react'
import { useLatest } from './useLatest'

export function useLatestCallback<F extends Function>(f: F): F {
  const ref = useLatest(f)
  return useMemo(
    () =>
      function () {
        return ref.current.apply(null, arguments)
      } as unknown as F,
    [ref]
  )
}
